import React, { useState } from 'react';
import { FiltersContainer, FilterLabel, FilterDropdown } from '../../../components';
import BulkDownloadDocumentsInsuredsSearchBy from './BulkDownloadDocumentsInsuredsSearchBy';
import { exposureStatusOptions } from '../../exposures/utils';

export default function BulkDownloadDocumentsInsuredsFilters({ defaults, onChange, filterValue }) {
  const [filters, setFilters] = useState(defaults);

  const orderOptions = [
    { label: 'First Name', value: 'FIRST_NAME' },
    { label: 'Last Name', value: 'LAST_NAME' }
  ];

  const updateFilter = values => {
    const newFilters = { ...filters, ...values };
    setFilters(newFilters);
    onChange(newFilters);
  };

  const statusOptions = exposureStatusOptions().filter(status => status?.value !== 'PENDING');

  return (
    <div>
      <FiltersContainer className="pb-0 mb-2 pt-3">
        <FilterLabel>Sort by</FilterLabel>
        <FilterDropdown
          id="ordering"
          className="mr-3"
          headerText="Sort ascending..."
          icon={['far', 'sort-alpha-down']}
          options={orderOptions}
          defaultOption={orderOptions.find(({ value }) => value === filterValue?.ordering)}
          setFilter={option => updateFilter({ ordering: option.value })}
        />
        <FilterLabel>Status</FilterLabel>
        <FilterDropdown
          id="election-status"
          className="mr-3"
          headerText="Status..."
          options={statusOptions}
          defaultOption={statusOptions.find(({ label }) => label === 'Active')}
          setFilter={option => updateFilter({ status: option?.value })}
          isClearable
        />
        <BulkDownloadDocumentsInsuredsSearchBy onChange={updateFilter} />
      </FiltersContainer>
    </div>
  );
}
